const DeletedMediaConstantsEn = {
  deletedMediaPageTitle: 'Deleted Media',
  deletedMediaTitle: 'Title',
  DeletedmediagoBack: 'Go Back',
  deletedMediaDeletedDate: 'Delete Date',
  deletedMediaId: 'Id',
  deletedMediaBrightcoveId:'Brightcove Id', 
  deletedMediaReferenceId:'Reference Id',
  totalDeletedMedia: 'Total Deleted Media',
  deletedMediaTableIdColumn: 'Id',
  deletedMediaTableTitleColumn: 'Title',
  deletedMediaTableDeletedDateColumn: 'Delete Date',
};
export default DeletedMediaConstantsEn;
